<template>
  <div class="wrap">
    <iframe
      v-if="
        previewable &&
        info.url &&
        !['doc', 'docx', 'pdf'].includes(info.fileType)
      "
      scrolling="no"
      ref="iframeContent"
      class="iframeContent"
      :src="`https://view.officeapps.live.com/op/view.aspx?src=${info.url}`"
      :srcdoc="datum_info.content"
      :height="iframeHeight"
      @load="iframeOnLoad"
    >
    </iframe>

    <div
      class="doc-preview"
      v-else-if="
        previewable &&
        info.url &&
        (info.fileType === 'doc' || info.fileType === 'docx')
      "
    >
      <a :href="`https://view.officeapps.live.com/op/view.aspx?src=${info.url}`"
        >点击word预览文档</a
      >
    </div>

    <div
      class="doc-preview"
      v-else-if="previewable && info.url && info.fileType === 'pdf'"
    >
      <Pdf ref="jsPdf" :pdfUrl="info.url" :is_encrypt="info.is_encrypt" />
    </div>
  </div>
</template>

<script>
import Pdf from "@/components/pdf/index.vue";

export default {
  components: {
    Pdf,
  },
  data() {
    return {
      previewable: false, // 是否可预览
      iframeLoading: true,
      iframeHeight: 0,
      info: {},
      datum_info: {},
    };
  },
  methods: {
    iframeOnLoad() {
      this.iframeLoading = false;
      this.iframeHeight =
        this.$refs["iframeContent"].contentWindow.document.body.scrollHeight;
    },
  },
  created() {
    const option = this.$route.params;
    this.previewable = option.previewable;
    this.info = option.info;
    this.datum_info = option.datum_info;
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  margin-top: -80px;
  height: calc(100vh - 15px);
  .iframeContent {
    width: 100%;
    min-height: calc(100vh - 44px);
    border: none;
  }
}
</style>
